import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BudgetsPage.QBooksBudgets.BudgetParams', {
    status: 'Status:',
    deactivated: 'Deactivated',
    active: 'Active',
    subdividedBy: 'Subdivided by:',
    customer: 'Customer',
    location: 'Location',
    class: 'Class',
    dontDivide: 'Don’t divide',
    lastSync: 'Last sync:',
    checkPeriod: 'Check period:',
    includeZeroAmountLabel: 'Show zero amounts:',
    zeroAmountConsider: 'Yes',
    zeroAmountNotConsider: 'No',
    checkPeriodMonthly: 'Month',
    checkPeriodQuarterly: '3 months',
    checkPeriodHalfYearly: '6 months',
    checkPeriodYearly: 'Year',
    checkPeriodYTD: 'Year to date',
    checkPeriodAnnuallyWithCustomFirstMonth: 'Yearly starting from {month}',
    checkPeriodYearToDateWithCustomFirstMonth: 'YTD starting from {month}',
    budgetPeriod: 'Budget period:',
});
